import { render, staticRenderFns } from "./EditPartnerSiteRedirectModal.vue?vue&type=template&id=1c1ab3ee&"
import script from "./EditPartnerSiteRedirectModal.vue?vue&type=script&lang=js&"
export * from "./EditPartnerSiteRedirectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports